export const categoryOptions = [
  { value: "salon", label: "סלון" },
  { value: "clinic", label: "קליניקה" },
  { value: "restaurant", label: "מסעדה" },
  { value: "cafe", label: "בית קפה" },
  { value: "shop", label: "חנות" },
  { value: "freelancer", label: "פרילנסר" },
  { value: "service", label: "נותן שירות" },
  { value: "beauty", label: "יופי וטיפוח" },
  { value: "health", label: "בריאות" },
  { value: "delivery", label: "משלוחים" },
] as const

export function getCategoryLabel(value: string) {
  return categoryOptions.find((option) => option.value === value)?.label ?? value
}
